import localstory from "localstory";
const store = typeof window !== "undefined" ? localstory(window.sessionStorage, "flights") : undefined;
const key = "flexOriginPrice";
const setOriginPrice = (price) => {
    store?.set(key, price, { ttl: "1d" });
};
const consumeOriginPrice = () => {
    const value = store?.get(key);
    store?.unset(key);
    return value;
};
export default function useFlexPriceDiffTracker() {
    return { setOriginPrice, consumeOriginPrice };
}
